/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {
  Animated, Platform, StyleProp, StyleSheet, TextStyle, View, ViewStyle
} from "react-native";
import SVG_Svg, {
  ClipPath as SVG_ClipPath, Defs, G as SVG_G, GProps, Path as SVG_Path, PathProps
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const ClipPath = Animated.createAnimatedComponent(SVG_ClipPath);
const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);

const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"> <desc id="IMP.BLUE">{"#AddButton":{"type":"SELECTOR","constraint":"xMinYMin meet","width":20,"height":20},"#Group":{"type":"SELECTOR","constraint":"none","width":8.57148551940918,"height":8.571443557739258},"#Vector":{"type":"SELECTOR","constraint":"none","width":8.57148551940918,"height":8.571443557739258},"transforms":{}}</desc>
 * <g id="AddButton" clip-path="url(#clip0)">
 * <g id="Group">
 * <g id="Group_2">
 * <path id="Vector" d="M16.4285 0H3.57141C1.59994 0.00234375 0.00234375 1.59994 0 3.57141V16.4285C0.00234375 18.4 1.59994 19.9976 3.57141 20H16.4285C18.4 19.9976 19.9976 18.4 20 16.4285V3.57141C19.9976 1.59994 18.4 0.00234375 16.4285 0ZM18.5714 16.4285C18.5714 17.612 17.612 18.5714 16.4285 18.5714H3.57141C2.38794 18.5714 1.42856 17.612 1.42856 16.4285V3.57141C1.42856 2.38794 2.38794 1.42856 3.57141 1.42856H16.4285C17.612 1.42856 18.5714 2.38794 18.5714 3.57141V16.4285Z" fill="#EDD4CB"/>
 * </g>
 * </g>
 * <g id="Group_3">
 * <g id="Group_4">
 * <path id="Vector_2" d="M13.5711 9.28574H10.7139V6.42859C10.7139 6.03409 10.3941 5.71429 9.99959 5.71429C9.60508 5.71429 9.28529 6.03409 9.28529 6.42859V9.28574H6.42817C6.03366 9.28574 5.71387 9.60553 5.71387 10C5.71387 10.3945 6.03366 10.7143 6.42817 10.7143H9.28533V13.5714C9.28533 13.9659 9.60513 14.2857 9.99963 14.2857C10.3941 14.2857 10.7139 13.9659 10.7139 13.5714V10.7143H13.5711C13.9656 10.7143 14.2854 10.3945 14.2854 9.99999C14.2854 9.60549 13.9655 9.28574 13.5711 9.28574Z" fill="#D89F8B"/>
 * </g>
 * </g>
 * </g>
 * <defs>
 * <clipPath id="clip0">
 * <rect width="20" height="20" fill="white"/>
 * </clipPath>
 * </defs>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#AddButton": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 20,
 * 		"height": 20
 * 	},
 * 	"#Group": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 8.57148551940918,
 * 		"height": 8.571443557739258
 * 	},
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 8.57148551940918,
 * 		"height": 8.571443557739258
 * 	},
 * 	"transforms": {}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const AddButton = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 20,
      height: 20,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;
  /** Component Internal State */

  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */
  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg
          fill="none"
          id="svg_root"
          ref={svgRef}
          {...props}
          style={svgStyle}
          preserveAspectRatio="xMinYMin meet"
          viewBox="0 0 20 20"
        >
          <G id="AddButton" clipPath="url(#clip0)">
            <Svg preserveAspectRatio="none" viewBox="0 0 20 20">
              <G id="Group">
                <G id="Group_2">
                  <Svg preserveAspectRatio="none" viewBox="0 0 20 20">
                    <Path
                      id="Vector"
                      d="M16.4285 0H3.57141C1.59994 0.00234375 0.00234375 1.59994 0 3.57141V16.4285C0.00234375 18.4 1.59994 19.9976 3.57141 20H16.4285C18.4 19.9976 19.9976 18.4 20 16.4285V3.57141C19.9976 1.59994 18.4 0.00234375 16.4285 0ZM18.5714 16.4285C18.5714 17.612 17.612 18.5714 16.4285 18.5714H3.57141C2.38794 18.5714 1.42856 17.612 1.42856 16.4285V3.57141C1.42856 2.38794 2.38794 1.42856 3.57141 1.42856H16.4285C17.612 1.42856 18.5714 2.38794 18.5714 3.57141V16.4285Z"
                      fill="#EDD4CB"
                      strokeWidth="1"
                      vectorEffect="non-scaling-stroke"
                    />
                  </Svg>
                </G>
              </G>
            </Svg>
            <G id="Group_3">
              <G id="Group_4">
                <Path
                  id="Vector_2"
                  d="M13.5711 9.28574H10.7139V6.42859C10.7139 6.03409 10.3941 5.71429 9.99959 5.71429C9.60508 5.71429 9.28529 6.03409 9.28529 6.42859V9.28574H6.42817C6.03366 9.28574 5.71387 9.60553 5.71387 10C5.71387 10.3945 6.03366 10.7143 6.42817 10.7143H9.28533V13.5714C9.28533 13.9659 9.60513 14.2857 9.99963 14.2857C10.3941 14.2857 10.7139 13.9659 10.7139 13.5714V10.7143H13.5711C13.9656 10.7143 14.2854 10.3945 14.2854 9.99999C14.2854 9.60549 13.9655 9.28574 13.5711 9.28574Z"
                  fill="#D89F8B"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
              </G>
            </G>
          </G>
          <Defs>
            <ClipPath id="clip0">
              <Path
                fill="white"
                id="clip0_elem0"
                d="M0 0 H20 a0,0 0 0 1 0,0 V20 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </ClipPath>
          </Defs>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 20 20"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <G id="Group">
          <G id="Group_2">
            <Path
              id="Vector"
              d="M16.4285 0H3.57141C1.59994 0.00234375 0.00234375 1.59994 0 3.57141V16.4285C0.00234375 18.4 1.59994 19.9976 3.57141 20H16.4285C18.4 19.9976 19.9976 18.4 20 16.4285V3.57141C19.9976 1.59994 18.4 0.00234375 16.4285 0ZM18.5714 16.4285C18.5714 17.612 17.612 18.5714 16.4285 18.5714H3.57141C2.38794 18.5714 1.42856 17.612 1.42856 16.4285V3.57141C1.42856 2.38794 2.38794 1.42856 3.57141 1.42856H16.4285C17.612 1.42856 18.5714 2.38794 18.5714 3.57141V16.4285Z"
              fill="#EDD4CB"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
          </G>
        </G>
        <Defs>
          <ClipPath id="clip0">
            <Path
              fill="white"
              id="clip0_elem0"
              d="M0 0 H20 a0,0 0 0 1 0,0 V20 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
          </ClipPath>
        </Defs>
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 20 20"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <G id="Group_3">
          <G id="Group_4">
            <Path
              id="Vector_2"
              d="M13.5711 9.28574H10.7139V6.42859C10.7139 6.03409 10.3941 5.71429 9.99959 5.71429C9.60508 5.71429 9.28529 6.03409 9.28529 6.42859V9.28574H6.42817C6.03366 9.28574 5.71387 9.60553 5.71387 10C5.71387 10.3945 6.03366 10.7143 6.42817 10.7143H9.28533V13.5714C9.28533 13.9659 9.60513 14.2857 9.99963 14.2857C10.3941 14.2857 10.7139 13.9659 10.7139 13.5714V10.7143H13.5711C13.9656 10.7143 14.2854 10.3945 14.2854 9.99999C14.2854 9.60549 13.9655 9.28574 13.5711 9.28574Z"
              fill="#D89F8B"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
          </G>
        </G>
        <Defs>
          <ClipPath id="clip0">
            <Path
              fill="white"
              id="clip0_elem0"
              d="M0 0 H20 a0,0 0 0 1 0,0 V20 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </View>
  );
};
/***/

export default React.memo(AddButton);
